import React, { useState } from 'react';
import StyledBox, {
  StyledMenu,
  StyledNavMenuItem,
} from 'views/rebranded-module/common/components/Logical/LayoutV2/NavBar/NavMenu/NavMenu.styles';
import {
  Button, Avatar, Typography, Divider,
} from '@mui/material';
import { RiAccountCircleFill, RiCloseFill, RiMenuFill } from 'react-icons/ri';
import { useSelector } from 'react-redux';

const NavMenu = (props) => {
  const { dropdownMenuItems } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { appState } = useSelector((state) => state.globalData);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen((prev) => !prev);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
    setIsMenuOpen(false);
  };
  return (
    <StyledBox>
      <Button
        className={`VMBtn ${isMenuOpen ? 'VMBtnActive' : ''}`}
        onClick={handleMenuClick}
        color="secondary"
        variant="contained"
        data-testid="user-menu-btn">
        {isMenuOpen ? <RiCloseFill /> : <RiMenuFill />}

        {appState.current_user ? (
          <Avatar
            className="NMAvatar"
            src={appState.current_user.avatar_url}
            alt={`${appState.current_user.first_name} ${appState.current_user.last_name}`}>
            {!appState.current_user.avatar_url && (
              <Typography component="span" className="NMAvaterLatter">
                {appState.current_user.first_name?.charAt(0).toUpperCase()}
              </Typography>
            )}
          </Avatar>
        ) : (
          <RiAccountCircleFill className="NMAccIcon" />
        )}
      </Button>
      <StyledMenu
        className="NMDropDown"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        disableScrollLock>
        {dropdownMenuItems.map((item) => (
          <>
            {item.isDivider ? (
              <Divider className="NMIDivider" />
            ) : (
              <StyledNavMenuItem
                key={item.label}
                item={item}
                onClick={(...args) => {
                  item.onClick?.apply(null, args);
                  handleMenuClose();
                }}
              />
            )}
          </>
        ))}
      </StyledMenu>
    </StyledBox>
  );
};

export { NavMenu };
